// extracted by mini-css-extract-plugin
export var sliderRange = "_r1-2";
export var sliderRoot = "_r1-0";
export var sliderThumb = "_r1-3";
export var sliderTrack = "_r1-1";